import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RepositoryService } from '@app/api/api';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
	selector: 'meu-modal-create-warehouse',
	templateUrl: './modal-create-warehouse.component.html',
	styleUrls: ['./modal-create-warehouse.component.scss']
})
export class ModalCreateWarehouseComponent implements OnInit {
	page = 1;
	filter = '';
	totalPage = 0;
	isEdit: boolean = false;
	public controlSearch: FormControl = new FormControl();
	constructor(
		public dialogRef: MatDialogRef<ModalCreateWarehouseComponent>,
		@Inject(MAT_DIALOG_DATA) public data,
		private warehouseService: RepositoryService,
	) { }
	warehouseForm = new FormGroup({
		name: new FormControl('', [Validators.required, Validators.pattern("^(?!\\s*$).+")]),
		code: new FormControl('', [Validators.required, Validators.pattern("^(?!\\s*$).+")]),
		address: new FormControl(''),
		longitude: new FormControl(),
		latitude: new FormControl(),
	});
	ngOnInit() {
		if (this.data.id != null) {
			this.isEdit = true;
			this.getWarehouseByID(this.data.id);
		}
	}
	getWarehouseByID(id) {
		this.warehouseService.apiRepositoriesIdGet(id).subscribe(res => {
			if (res.success) {
				this.warehouseForm.patchValue({
					name: res.data.name,
					code: res.data.code,
					address: res.data.address,
					longitude: res.data.longitude,
					latitude: res.data.latitude,
				})
			}
		})
	}
	save() {
		if (this.warehouseForm.value.longitude == null) {
			this.warehouseForm.value.longitude = 0;
		}
		if (this.warehouseForm.value.latitude == null) {
			this.warehouseForm.value.latitude = 0;
		}
		const controls = this.warehouseForm.controls;
		if (this.warehouseForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}
		if (!this.isEdit) {
			this.warehouseService.apiRepositoriesPost(this.warehouseForm.value).subscribe(res => {
				if (res.success) {
					this.dialogRef.close({ event: true, type: "create" });
				} else {
					this.dialogRef.close({ event: false });
				}
			})
		} else {
			this.warehouseService.apiRepositoriesIdPut(this.data.id, this.warehouseForm.value).subscribe(res => {
				if (res.success) {
					this.dialogRef.close({ event: true });
				} else {
					this.dialogRef.close({ event: false });
				}
			})
		}
	}

	closeModal() {
		this.dialogRef.close();
	}
}
